import { render, staticRenderFns } from "./RelationsList.vue?vue&type=template&id=75eaff8f&scoped=true&"
import script from "./RelationsList.vue?vue&type=script&lang=js&"
export * from "./RelationsList.vue?vue&type=script&lang=js&"
import style0 from "./RelationsList.vue?vue&type=style&index=0&id=75eaff8f&lang=scss&scoped=true&"
import style1 from "./RelationsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75eaff8f",
  null
  
)

export default component.exports